// extracted by mini-css-extract-plugin
module.exports = {"footerText":"footer_footerText__2gc9j"};